import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";
//cdkDrag
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: "kreform-drag-drop",
  template: `
  <div class="formly-drag-drop"  (cdkDropListDropped)="drop($event)" cdkDropList [cdkDropListData]="field.fieldGroup">
  <div class="formly-drag-drop">
    <ng-container *ngFor="let field of field.fieldGroup;let index=index;" > 
       
      <div   class="formly-drag-drop_wrap" cdkDrag>  
        <div class="field-content">
        <kreform-field [field]="field"></kreform-field>
        </div>
      </div>
    </ng-container> 
  </div>
  
  <ng-container *ngIf="field.fieldGroup==null || field.fieldGroup.length==0" >
 
</ng-container>
  `
})
export class KreFormDragDrop extends FieldType {
  service: any;

  get insertQuestionIndex(){
    let result = -1;
    if(this.to.index){
      result = this.to.index;
    }
    return result;
  };
  constructor(dyService: KreFormAntService) {
    super();
    this.service = dyService;
  }
  
 
  drop(event: CdkDragDrop<string[]>) { 
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      // this.service.dragDropOperational(
      //   event.previousContainer.data,
      //   event.previousIndex,
      //   event.currentIndex);
    }
  }
  fieldOperational(sign: string) {
    //his.service.fieldOperational(sign, this.field);
  }

  
  //设置逻辑
  logicQuestion(field:any){
    //this.service.questionOperational("logic",field);
  }
  //拷贝题目
  copyQuestion(field:any){ 
   // this.service.questionOperational("copy",field);
  }
  //删除题目
  delQuestion(field:any)
  {  
    //this.service.questionOperational("delete",field);
  }
  //点击题目
  activeQuestion(field:any){
    // if(!this.field.active){ 
    //   this.service.questionOperational("active",field);
    // }
  }

}
